var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { getCategory } from '../core/utils';
import { RouteList } from '../routes';
var defaultBookingSteps = [
    RouteList.CATEGORY,
    RouteList.STORE,
    RouteList.DATETIME,
    RouteList.CONTACTS,
    RouteList.CONFIRMATION,
];
var getBookingSteps = function (category) {
    if (!category)
        return [];
    var bookingSteps = __spreadArray([], defaultBookingSteps, true);
    return bookingSteps;
};
export var useBookingSteps = function () {
    var pathname = useLocation().pathname;
    var category = useSelector(getCategory);
    var bookingSteps = useMemo(function () { return getBookingSteps(category); }, [
        category,
    ]);
    var currentStepIndex = useMemo(function () { return bookingSteps.findIndex(function (route) { return pathname.includes(route); }); }, [bookingSteps, pathname]);
    return useMemo(function () { return ({
        nextStep: bookingSteps[currentStepIndex + 1],
        totalSteps: bookingSteps.length,
        currentStepNumber: currentStepIndex + 1,
    }); }, [pathname, category]);
};
